import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgNull = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='m6.106 6.92-.829 4.556a15.4 15.4 0 0 1-.852 2.962l-.876 2.19A1 1 0 0 0 4.477 18h15.046a1 1 0 0 0 .928-1.371l-.876-2.19a15.4 15.4 0 0 1-.852-2.963l-.828-4.557a5.991 5.991 0 0 0-11.79 0M11 4.75a1 1 0 0 1 1-1 4.24 4.24 0 0 1 4.173 3.482 1 1 0 0 1-1.968.358A2.24 2.24 0 0 0 12 5.75a1 1 0 0 1-1-1'
      clipRule='evenodd'
      opacity={0.2}
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M12 18.5H4.618a2 2 0 0 1-1.789-2.894l.347-.695a13.5 13.5 0 0 0 1.212-3.634l.734-4.037a6.991 6.991 0 0 1 13.756 0l.734 4.037a13.5 13.5 0 0 0 1.212 3.634l.347.695a2 2 0 0 1-1.789 2.894h-4.554A3 3 0 0 1 9.403 21a1 1 0 1 1 1.732-1A1 1 0 1 0 12 18.5M7.09 7.598a4.991 4.991 0 0 1 9.82 0l.735 4.037a15.6 15.6 0 0 0 1.39 4.17l.347.695H4.618l.347-.695a15.5 15.5 0 0 0 1.39-4.17z'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgNull)
export default ForwardRef
